export const toastOptions = {
  theme: 'light',
};
